/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-07-07 15:33:17
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-07-07 18:58:33
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\DoctorSnurses\src\case-4\index.js
 */

import request from '@/utils/req.js';

//客服消息处理 人员列表接口
export function nursing_service_im(params) {
    return request.post("/admin/nursing-service-im/list",params);
}
//根据当前用户获取右侧信息
export function nursing_service_info(params) {
    return request.get(`/admin/nursing-service/${params}`);
}

